import { DashboardModuleMessage, MessageTarget } from '@fmh/carenarrativemodule';

export const environment = {
    apiUrl: 'https://dev-patientchat.followmy.health',
    hostMessageTarget: window.parent as MessageTarget<DashboardModuleMessage>,
};
